import axios from 'axios'
/**
 * decideAction service
 * we can Authorize or reject a finiquito
 * 
 */
export default async (route) => {
    try {
        let response = await axios.post(route)
        return response
    } catch (error) {
        console.log(error.response,'error')
        return error.response.data
    }
}